export const randomString = function (length = 10) {
  let charset =
      'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
    str = '';

  for (let i = 0, n = charset.length; i < length; ++i) {
    str += charset.charAt(Math.floor(Math.random() * n));
  }

  return str;
};
